import { render, staticRenderFns } from "./SoliStatusAvatar.vue?vue&type=template&id=137458b1"
import script from "./SoliStatusAvatar.vue?vue&type=script&lang=js"
export * from "./SoliStatusAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports